/**
 * @license lucide-react v1.59.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.mjs';

const __iconData = {
  name: "face-angry",
  size: 24,
  node: [
    ["path", { d: "M15 12v-1.584", key: "1md67h" }],
    ["path", { d: "M17 10a5 5 0 00-3 1", key: "1dqs4m" }],
    ["path", { d: "M7 10a5 5 0 013 1", key: "1okmnq" }],
    ["path", { d: "M9 12v-1.584", key: "cfo04w" }],
    ["path", { d: "M9 17a5 5 0 016.001 0", key: "ipdrmp" }],
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
  ],
  aliases: ["angry"]
};
__iconData.node;
const FaceAngry = createLucideIcon(__iconData);

export { __iconData, FaceAngry as default };
//# sourceMappingURL=face-angry.mjs.map
